// src/components/task/TaskApi.tsx
import axios from 'axios';
import { API_ENDPOINTS } from '../../../apiConfig';

export interface TaskDTO {
  id: string;
  tenantId: string;
  tenantName?: string;
  contractId?: string;
  projectId: string;
  projectName?: string;
  parentId?: string;
  hierarchyPath?: string;

  title: string;
  description?: string;
 
  estimatedQuantity?: number;
  units?: string;
  estimatedRate?: number;
  taxPercentage?: number;

  actualQuantity?: number;
  actualRate?: number;

  estimatedEffortHours?: number;
  actualEffortHours?: number;

  status?: string;
  taskType?: string;
  priority?: string;
  givenStartDate?: string;
  givenEndDate?: string;
  actualStartDate?: string;
  actualEndDate?: string;
  progress?: number;

 
  isMilestone?: boolean;
  isBillable?: boolean;
  isDeleted?: boolean;

  assignedTo?: string;
  completedBy?: string;
  approvedBy?: string;
  approvalDate?: string;
  isApproved?: boolean;
  rejectionReason?: string;

  reviewRequestedBy?: string;
  reviewRequestedAt?: string;
  rejectedBy?: string;
  rejectedAt?: string;

  terminationReason?: string;
  comment?: string;

  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
 
}

export interface ReportTaskDTO {
  id: string;
  tenantId: string;
  tenantName?: string;
  contractId?: string;
  projectId: string;
  projectName?: string;
  parentId?: string;
  hierarchyPath?: string;

  title: string;
  description?: string;
 
  estimatedQuantity?: number;
  units?: string;
  estimatedRate?: number;
  taxPercentage?: number;

  actualQuantity?: number;
  actualRate?: number;

  estimatedEffortHours?: number;
  actualEffortHours?: number;

  status?: string;
  taskType?: string;
  priority?: string;
  givenStartDate?: string;
  givenEndDate?: string;
  actualStartDate?: string;
  actualEndDate?: string;
  progress?: number;

  estimatedTotalTaxAmount?: number;
   estimatedTotalAmountWithoutTax?: number;
   estimatedTotalAmountWithTax?: number;
  actualTotalTaxAmount?: number;
   actualTotalAmountWithoutTax?: number;
   actualTotalAmountWithTax?: number;
  isMilestone?: boolean;
  isBillable?: boolean;
  isDeleted?: boolean;

  assignedTo?: string;
  completedBy?: string;
  approvedBy?: string;
  approvalDate?: string;
  isApproved?: boolean;
  rejectionReason?: string;

  reviewRequestedBy?: string;
  reviewRequestedAt?: string;
  rejectedBy?: string;
  rejectedAt?: string;

  terminationReason?: string;
  comment?: string;

  createdBy?: string;
  updatedBy?: string;
  createdAt?: string;
  updatedAt?: string;
  // ✅ Add this for nested structure
  children?: TaskDTO[];
}
export type NestedTaskDTO = ReportTaskDTO & { children?: NestedTaskDTO[] };
export interface TaskFilterDTO {
  status?: string;
  taskType?: string;
  priority?: string;
  projectName?: string;
  projectId?: string;
  tenantId?: string;
  title?: string;
  assignedTo?: string;
  givenStartDate?: string;
  givenEndDate?: string;
  
}

const API_BASE = `${API_ENDPOINTS.project}/tasks`;

export const TaskApi = {
  create: (data: TaskDTO) => axios.post(`${API_BASE}`, data),
  update: (id: string, data: TaskDTO) => axios.put(`${API_BASE}/${id}`, data),
  delete: (id: string) => axios.delete(`${API_BASE}/${id}`),
  getById: (id: string) => axios.get(`${API_BASE}/${id}`),
  filter: (filter: TaskFilterDTO) => axios.post(`${API_BASE}/filter`, filter),

  bulkUpload: async (
    file: File,
    projectId: string,
    projectName: string,
    tenantId: string,
    tenantName: string,
    userId: string,
    username: string
  ): Promise<void> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('projectId', projectId);
    formData.append('projectName', projectName);
    formData.append('tenantId', tenantId);
    formData.append('tenantName', tenantName);
    formData.append('userId', userId);
    formData.append('username', username);

    await axios.post(`${API_BASE}/upload-excel`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

};
//------------ Task Dashboard API
export interface TaskDashboardResponse {
  task_completion: {
    project_id: string;
    project_name: string;
    task_completion_percentage: number;
    task_incompletion_percentage: number;
  }[];
  task_status_breakdown: {
    project_id: string;
    project_name: string;
    status: string;
    task_count: number;
  }[];
  overdue_tasks: {
    id: string;
    project_id: string;
    project_name: string;
    task_name: string;
    given_end_date: string;
    status: string;
  }[];
  cost_per_task: {
    id: string;
    project_id: string;
    project_name: string;
    task_name: string;
    estimated_cost: number;
    actual_cost: number;
  }[];
  tax_breakdown: {
    project_id: string;
    project_name: string;
    estimated_total_tax: number;
    actual_total_tax: number;
  }[];
}
const API_DASBOARD = `${API_ENDPOINTS.project}/kpi`;
export const TaskDashboardApi = {
  getDashboardData: async (): Promise<TaskDashboardResponse> => {
    const response = await axios.get(`${API_DASBOARD}/project-task`);
    return response.data;
  },
};
